/* eslint-disable import/no-cycle */
import React from 'react'
import Report from '../../Report/Report'
const UserReport = (props) => {
  const { value, onclose, drawer } = props

  return <Report value={value} isUser onclose={onclose} drawer={drawer} />
}
export default UserReport
